<script>
import { usersMethods } from '@state/helpers'
import { required, minLength, email, sameAs, helpers } from 'vuelidate/lib/validators'

const passwordStrength = helpers.regex('passwordStrength', /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/)

export default {
  name: 'TempPassword',
  props: {

  },
  components: { 
  },
  data() {
    return {
      updatePwForm: {
        password: '',
        repeat_password: ''
      },
      isChangingPassword: false,
      hidePassword: true,
      hideRepeatPassword: true,
    }
  },
  validations: {
    updatePwForm: {
      password: {
        required,
        minLength: minLength(6),
        passwordStrength,
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs('password')
      },
    },
  },
  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null;
    },
  },
  methods: {
    ...usersMethods,

    async setPassword(evt) {
      evt.preventDefault();
      const url = this.$store.state.auth.currentSession.user.url;
      this.isChangingPassword = true;
      try {
        await this.changePassword({ url, password: this.updatePwForm.password });
        await this.changeFirstLoginAction({ url, isFirstLogin: false });
      } catch (error) {
        this.$axios_error_noty(error, this);
        return;
      }
      this.isChangingPassword = false;
      this.$generate_toast( this, 'success', this.$t('login_section.password_changed_successfully'));
      this.$emit('passwordChanged');
    },
    getPasswordType(value) {
      return value ? 'password' : 'text'
    },
    getPasswordIcon(value) {
      return value ? 'fa-eye' : 'fa-eye-slash'
    },
  },
}
</script>

<template>
  <div class="card bg-pattern">
    <div class="card-body p-4 pb-0">
      <div class="w-75 m-auto">
        <span>
          <b-img
            v-if="getCompanyInfo"
            :src="getCompanyInfo['dark_logo'] || require('@assets/images/logos/logo-dark.png')"
            alt="login"
            class="p-1 pb-2"
            fluid
          />
        </span>
      </div>
      <div class="text-dark mb-2 text-center">
        {{ $t('login_section.your_current_password_is_temporary') }}
      </div>

      <b-form @submit.prevent="setPassword">
        <b-form-group
          id="input-group-1"
          label-for="input-1"
          class="mb-0"
        >
          <slot name="label">
            <label class="d-block">
              {{ $t('password') }} 
              <i
                class="fas" 
                :class="[getPasswordIcon(hidePassword)]" 
                @click="hidePassword = !hidePassword"
              >
              </i>
            </label>
          </slot>
          <b-form-input
            id="input-1"
            required
            v-model="updatePwForm.password"
            :type="getPasswordType(hidePassword)"
          ></b-form-input>
          <div class="text-warning mb-1">
            <div v-if="!$v.updatePwForm.password.minLength">
              *{{ $t('validation.minPasswordLength', { minLength: $v.updatePwForm.password.$params.minLength.min }) }}
            </div>
            <div v-if="!$v.updatePwForm.password.passwordStrength">
              *{{ $t('validation.passwordStrength') }}
            </div>
          </div>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label-for="input-2"
          class="mb-0 mt-2"
        >
          <slot name="label">
            <label class="d-block">
              {{ $t('repeat_password') }} 
              <i 
                class="fas" 
                :class="[getPasswordIcon(hideRepeatPassword)]" 
                @click="hideRepeatPassword = !hideRepeatPassword"
              >
              </i>
            </label>
          </slot>
          <b-form-input
            id="input-2"
            required
            v-model="updatePwForm.repeat_password"
            :type="getPasswordType(hideRepeatPassword)"
          ></b-form-input>
          <div class="text-warning" v-if="!$v.updatePwForm.repeat_password.sameAsPassword">
            *{{ $t('validation.sameAsPassword') }}
          </div>
        </b-form-group>

        <b-form-group id="button-group" class="mt-4 mb-0">
          <b-button
            type="submit"
            variant="primary"
            class="btn-block "
            :disabled="isChangingPassword || $v.updatePwForm.$invalid"
          >
            <span v-if="!isChangingPassword">
              {{ $t('submit') }}
            </span>
            <b-spinner
              v-if="isChangingPassword"
              small
              label="Spinning"
              variant="light"
            >
            </b-spinner>
          </b-button>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>
